import script from "./SummaryContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SummaryContent.vue?vue&type=script&setup=true&lang=ts"

import "./SummaryContent.vue?vue&type=style&index=0&id=924385e4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-924385e4"]])

export default __exports__